import React from 'react';
import { Button, Input, Modal, Popconfirm, Space, Tag, Tooltip, message } from 'antd';
import tmAdminExtService from '../../services/tmAdminExtService';
import { ok, toastErr } from './common';

export const pct = (v, digits = 2) => (v === null || v === undefined ? '-' : `${(v * 100).toFixed(digits)}%`);

export const askReason = (title, defaultReason, onOk, danger = true) => {
    let value = '';
    Modal.confirm({
        title,
        content: <Input.TextArea rows={2} maxLength={200} placeholder={defaultReason} onChange={(e) => { value = e.target.value; }} />,
        okButtonProps: { danger },
        onOk: () => onOk(value.trim() || defaultReason),
    });
};

/** Runs an ops call, toasts, then onDone(). */
export const runOp = async (fn, okText, onDone) => {
    try {
        const r = await fn();
        if (ok(r)) {
            message.success(r.message && r.message !== 'success' ? r.message : okText);
            if (r.data?.warning) message.warning(r.data.warning);
            onDone && onDone(r);
        }
        return r;
    } catch (e) {
        toastErr(e, '操作失败');
        return null;
    }
};

/** Pause / resume / ban / unban buttons for a stream {id, status} (logged endpoints). */
export const StreamQuickActions = ({ stream, onDone, size = 'small' }) => {
    if (!stream?.id || stream.status === 'terminated') return null;
    const id = stream.id;
    const op = (fn, text) => runOp(fn, text, onDone);
    return (
        <Space size={4} wrap>
            {stream.status === 'active' && (
                <Button size={size} onClick={() => askReason('暂停发信流', '管理员暂停', (r) => op(() => tmAdminExtService.pause(id, r), '已暂停'))}>暂停</Button>
            )}
            {stream.status === 'paused' && <Button size={size} onClick={() => op(() => tmAdminExtService.resume(id), '已恢复')}>恢复</Button>}
            {stream.status !== 'banned'
                ? <Button size={size} danger onClick={() => askReason('封禁（吊销全部密钥）', '管理员封禁', (r) => op(() => tmAdminExtService.ban(id, r), '已封禁'))}>封禁</Button>
                : (
                    <Popconfirm title="解封后用户需重建密钥" onConfirm={() => op(() => tmAdminExtService.unban(id), '已解封')}>
                        <Button size={size}>解封</Button>
                    </Popconfirm>
                )}
        </Space>
    );
};

const STATUS_COLOR = { active: 'green', paused: 'orange', suspended: 'default', banned: 'red', terminated: 'default' };
export const StreamRef = ({ stream, onOpen }) => {
    if (!stream?.id) return '-';
    return (
        <Space size={4}>
            <Tooltip title={stream.status}>
                <Tag color={STATUS_COLOR[stream.status]} style={{ marginInlineEnd: 0, cursor: onOpen ? 'pointer' : undefined }} onClick={() => onOpen && onOpen(stream.id)}>
                    #{stream.id} {stream.name || ''}
                </Tag>
            </Tooltip>
        </Space>
    );
};
